<template>
  <footer class="app-footer">
    <span><a href="#">Market Scan</a> &copy; {{ new Date().getFullYear() }}</span>
    <span class="ml-auto"></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue